// Module
var code = `<h1 translate>Okta Login</h1> <p> <translate> Okta is a new login system for the Event Registration Tool which replaces the Relay login system. </translate> </p> <p> <translate> When you select Okta to login with, you can simply enter your same username and password as you did with Relay. </translate> </p> `;
// Exports
var _module_exports =code;;
var path = '/views/oktaDescription.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;